export default __webpack_public_path__ + "static/media/5.0e8a0c42.webp";